"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApMenuTriggerBordered = exports.ApMenuTriggerBorderedInternal = void 0;
/* tslint:disable */
var React = require("react");
var react_1 = require("react");
/* tslint:enable */
var theme_1 = require("../../utils/theme");
var styles_1 = require("./styles");
exports.ApMenuTriggerBorderedInternal = react_1.forwardRef(function (_a, ref) {
    var children = _a.children, icon = _a.icon, isOpen = _a.isOpen, props = __rest(_a, ["children", "icon", "isOpen"]);
    return (React.createElement(styles_1.BorderedTriggerWrapper, __assign({ icon: icon }, props, { ref: ref }),
        React.createElement(styles_1.BorderedTrigger, null,
            icon && React.createElement(styles_1.TriggerIcon, { iconName: icon }),
            "  ",
            children),
        React.createElement(styles_1.BorderedCaret, { iconName: 'caret', iconColor: theme_1.colors.grey700, isOpen: isOpen })));
});
exports.ApMenuTriggerBordered = react_1.memo(exports.ApMenuTriggerBorderedInternal);
//# sourceMappingURL=ApMenuTriggerBordered.js.map